module.exports = __webpack_public_path__ + "static/media/zera_putting_box_01.8b38a5d0.gif";